import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import * as API from "api";
import { useAuth } from "hooks";

import { isBuilding, getGoogleRedirect } from "utils";
import { ROUTE } from "route";

export const AuthGoogle = () => {
  const auth = useAuth();
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    const h = new URLSearchParams(decodeURIComponent(location.hash));

    fetch(API.user(), {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({
        type: 'google',
        token: h.get('id_token'),
      })
    })
      .then(res => res.json())
      .then(ishara => {
        if(isBuilding()) return;

        localStorage.setItem('ishara', ishara);
        auth.setIsAuth(true);
        const googleRedirect = getGoogleRedirect() || localStorage.getItem('googleRedirect');
        localStorage.removeItem('googleRedirect');
        if(googleRedirect) {
          return history.replace(googleRedirect);
        }
        history.replace(ROUTE.SCAN);
      });
  }, []);
  return (
    <div>redirect...</div>
  );
};
